// Gradients taken from: https://webgradients.com/
const menuData = [
  {
    id: "intro",
    name: "Reels",
    imageUrl: "https://images.pexels.com/photos/752525/pexels-photo-752525.jpeg?w=200",
  },
  {
    id: "collection",
    name: "Recents",
    imageUrl: "https://images.pexels.com/photos/4067759/pexels-photo-4067759.jpeg?w=200",
  },
  {
    id: "gallery",
    name: "Collection",
    imageUrl: "https://images.pexels.com/photos/297494/pexels-photo-297494.jpeg?w=200",
  },
  {
    id: "about",
    name: "Behind the Lens",
    imageUrl: "https://images.pexels.com/photos/6648418/pexels-photo-6648418.jpeg?w=200",
  },
];

export default menuData;
